import { createSlice } from '@reduxjs/toolkit';
import { REHYDRATE } from 'redux-persist';

const defaultStepData = {
  step0: {
    gender: null,
    age: '',
    eyeColor: null,
    hairColor: null,
    ethnicity: null,
  },
  step1: {
    selectedImages: [],
    uploadedSelfies: [],
  },
  step2: {
    paymentDetails: null,
  },
};

const initialState = {
  activeStep: 0,
  stepData: defaultStepData,
  currentPhotoPackId: null,
  isLoadingPhotos: false,
  isUploadingPhotos: false,
  error: null,
};

const photoStepSlice = createSlice({
  name: 'photoStep',
  initialState,
  reducers: {
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },

    updateStepData: (state, action) => {
      const { step, data } = action.payload;
      state.stepData[`step${step}`] = {
        ...state.stepData[`step${step}`],
        ...data
      };
    },

    // Set which photo pack/style user is working on
    setCurrentPhotoPack: (state, action) => {
      // If different pack selected, reset everything
      if (state.currentPhotoPackId !== action.payload) {
        state.activeStep = 0;
        state.stepData = defaultStepData;
        state.currentPhotoPackId = action.payload;
      }
    },

    // Reset everything (used when switching styles)
    resetAll: (state) => {
      return initialState;
    },

    // Loading states
    setLoading: (state, action) => {
      state.isLoadingPhotos = action.payload;
    },
    
    setUploading: (state, action) => {
      state.isUploadingPhotos = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      const incoming = action.payload?.photoStep;
      if (!incoming) {
        return;
      }

      state.activeStep = incoming.activeStep ?? 0;
      state.currentPhotoPackId = incoming.currentPhotoPackId ?? null;
      state.stepData = {
        ...defaultStepData,
        ...incoming.stepData,
        step0: { ...defaultStepData.step0, ...incoming.stepData?.step0 },
        step1: { ...defaultStepData.step1, ...incoming.stepData?.step1 },
        step2: { ...defaultStepData.step2, ...incoming.stepData?.step2 },
      };
    });
  },
});

export const { 
  setActiveStep, 
  updateStepData, 
  setCurrentPhotoPack,
  resetAll,
  setLoading,
  setUploading,
  setError 
} = photoStepSlice.actions;

export default photoStepSlice.reducer;